import React, { useState, useEffect } from "react";
import Skills from "./Skills";

interface AboutContent {
  id: string;
  content: string;
}

const About: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const about_me: AboutContent[] = [
    {
      id: "first-p-about",
      content:
        "Ik ben een enthousiaste engineer met een passie voor technologie die zowel simpele als complexe taken automatiseert. Op professioneel vlak ben ik gespecialiseerd in het automatiseren van bedrijfsprocessen met behulp van maatwerk software en AI. Als breed ervaren IT specialist heb ik aan meerdere projecten gewerkt waarbij ik handmatige processen transformeer naar efficiënte, geautomatiseerde oplossingen. Mijn expertise als full-stack software engineer, CI/CD specialist en testanalist stelt me in staat om end-to-end automatiseringsoplossingen te realiseren.",
    },
    {
      id: "second-p-about",
      content:
        "Het werk dat ik aflever dient voor mij in ieder geval één belangrijk doel; jouw processen efficiënter, sneller of zelfs automatisch maken, zodat jij je kan focussen op ondernemen. Om tot een oplossing te komen ga ik graag creatief en open-minded te werk en neem ik alle mogelijkheden en wensen in mijn overweging mee.",
    },
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section id="about" className="about-mf pt-3 route">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 px-4">
            <div className="box-shadow-full p-4">
              <div className="row">
                <div className="col-12">
                  <div className="about-me">
                    <div className="title-box-2">
                      <h5 className="title-left">Over mij</h5>
                    </div>
                    {about_me.map((content) => (
                      <p className="lead" key={content.id}>
                        {content.content}
                      </p>
                    ))}
                    <Skills />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
